import { render } from "./BaseInputRadio.vue?vue&type=template&id=28d10cc4&scoped=true&ts=true&lang=pug"
import script from "./BaseInputRadio.vue?vue&type=script&lang=ts"
export * from "./BaseInputRadio.vue?vue&type=script&lang=ts"

import "./BaseInputRadio.vue?vue&type=style&index=0&id=28d10cc4&lang=scss&scoped=true"

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d10cc4"]])

export default __exports__